import { render } from "./SelectRadio.vue?vue&type=template&id=6e8f8b73&scoped=true"
import script from "./SelectRadio.vue?vue&type=script&lang=js"
export * from "./SelectRadio.vue?vue&type=script&lang=js"

import "./SelectRadio.vue?vue&type=style&index=0&id=6e8f8b73&lang=less&scoped=true"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8f8b73"]])

export default __exports__